import React, {useContext, useEffect} from 'react';
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";
import {Alert} from "antd";
import {Translate} from "./translation.util";

export const ResponseMessageUtil: React.FC = observer(() => {
    const { appStore: {
        responseType,
        responseMessage,
        resetResponseMessageType,
        responseMessageDomain
    } } = useContext(StoreContext);

    useEffect(() => {
        const timeId = setTimeout(() => {
            resetResponseMessageType();
        }, 10000)

        return () => { clearTimeout(timeId) }
    }, [responseMessage, responseType, responseMessageDomain, resetResponseMessageType]);

    if (!responseMessage || !responseType) {
        return null;
    }

    return (
        <Alert
            showIcon
            closable
            style={{ marginBottom: "16px" }}
            message={<Translate message={responseMessage} domain={responseMessageDomain} />}
            type={responseType as any}
            onClose={resetResponseMessageType}
        />
    );
});